import { QueryClient } from '@tanstack/react-query';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: Infinity,
            cacheTime: 10 * 60 * 1000,
            refetchOnWindowFocus: false
        },
        mutations: {
            networkMode: 'always'
        }
    }
});
// WHY: boot seeds this key once and its readers (enabled: false) never refetch, so a GC with no observer hides integration-gated UI until reload (ANCR-2557).
queryClient.setQueryDefaults([
    QueryKeys.Integrations
], {
    cacheTime: Infinity
});
